import { useCallback } from "react";

import { useTerminalContext } from "../contexts/TerminalContext";
import { AssignStoragePlacesPayload, configApi } from "../services/configApi";
import { createWithLoading, wrapError } from "../utils/configApiHelpers";

/**
 * Hook for assigning storage places in terminal configuration
 */
export const useStoragePlaceAssigner = () => {
  const { setError, setIsLoading } = useTerminalContext();

  const assignStoragePlaces = useCallback(
    async (payload: AssignStoragePlacesPayload) => {
      setError(null);
      const withLoading = createWithLoading(setIsLoading);
      return withLoading(async () => {
        try {
          return await configApi.assignStoragePlaces(payload);
        } catch (error: any) {
          console.error("Failed to assign places:", error);
          setError(error.message || "Failed to assign places");
          throw wrapError("Failed to assign places", error);
        }
      });
    },
    [setError, setIsLoading]
  );

  return { assignStoragePlaces };
};
